import { AppHeader, AppSidebar, AppContent } from "./index"
// import { useNavigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { toggleDrawer, openDrawer, closeDrawer } from "../features/drawerSlice";
import { openAlert, closeAlert, toggleAlert } from "../features/alertSlice";


const Main = () => {
    const dispatch = useDispatch();
    const isAlert = useSelector((state) => state.alert);
    const isDrawer = useSelector((state) => state.drawer);

    const handleDrawerToggle = () => {
        if (isDrawer === true) {
            dispatch(closeDrawer());
        } else {
            dispatch(openDrawer());
        }
    };

    const handleAlertToggle = () => {
        if (isAlert === true) {
            dispatch(closeAlert());
        } else {
            dispatch(openAlert());
        }
    };
    return (
        <Box sx={{ display: "flex" }} id="main-content">
            <CssBaseline />
            <AppHeader drawerToggle={handleDrawerToggle} alertToggle={handleAlertToggle} alertState={isAlert} />
            <AppSidebar drawerOpen={isDrawer} alert={isAlert} />
            {/* <LoadingOverlay
                active={isLoading}
                spinner
                text='Loading your content...'
            > */}
            <AppContent />
            {/* </LoadingOverlay> */}
            {/* <AppFooter /> */}
        </Box>

    )

};


export default Main;